import React from 'react'

function UserAppointmentsPage() {
  return (
    <div>UserAppointmentsPage</div>
  )
}

export default UserAppointmentsPage;